module.exports = __webpack_public_path__ + "img/arrow_back_black_24dp.9b1948b4.svg";